

































import { Component, Vue } from 'vue-property-decorator';
import { mdbRow, mdbView, mdbMask, mdbBtn, mdbIcon, mdbParallax, mdbContainer, mdbCol } from '@folky-tools/mdbvue';

@Component({
    components: {
        mdbRow,
        mdbView,
        mdbMask,
        mdbBtn,
        mdbIcon,
        mdbParallax,
        mdbContainer,
        mdbCol,
        NavbarLoggedIn: () => import('@/components/shared/NavbarLoggedIn.vue'),
        EnterButton: () => import('@/components/shared/EnterButton.vue'),
        FooterPanel: () => import('@/components/shared/FooterPanel.vue')
    }
})
export default class HomeView extends Vue {
    private navbarClasses: string = 'transparent';

    private mounted(): void {
        this.$root.$emit('changeNavbarClasses', this.navbarClasses);
    }

    private randomStyle() {
        switch (Math.floor(Math.random() * Math.floor(4))) {
            case 0:
                return 'child';
            case 1:
                return 'lighthouse';
            case 2:
                return 'users';
            case 3:
                return 'hands';
            default:
                return 'lighthouse';
        }
    }
}
